import {Widget} from '@dv5/domain'

export const GRID_SIZE = 8

export const roundToGrid = (value: number): number => Math.round(value / GRID_SIZE) * GRID_SIZE

export const alignWidgetsToGrid = (widgets: Array<Widget>): Array<{id: string; left: number; top: number}> =>
    widgets.map(w => ({ id: w.id, left: roundToGrid(w.left), top: roundToGrid(w.top) }))
